import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmProjectCustomerNotificationsRuleRoute: InvariantJiraRoute = {
	name: 'csm-project-customer-notifications-rule',
	path: '/jira/customer-service-management/experiences/projects/:projectKey/settings/:helpCenterId/customer-notifications/rule/:ruleSetId',
	exact: true,
};
